export const pages = {
  campaign: 'campaign',
  storyEnhancerDemo: 'ai-story-enhancer-demo',
  team: 'team',
  fundraising: 'fundraising',
  crowdfunding: 'crowdfunding',
  claim: 'claim',
};
